module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer",
    class: _vm.footerClass
  }, [_c('div', {
    staticClass: "c-footer__container"
  }, [_vm._l((_vm.footer), function(item) {
    return (typeof _vm.footer !== 'undefined' && _vm.footer.length) ? [(item.linkType == 'external') ? _c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), (item.linkType == 'internal') ? _c('router-link', {
      attrs: {
        "target": item.target,
        "to": {
          name: 'Page_' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()] : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cebb1da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/AppFooter.vue
// module id = 539
// module chunks = 1